// extracted by mini-css-extract-plugin
export default {"modal-link":"_1jHcw","modalLink":"_1jHcw"};